export default "__VITE_ASSET__B565Rb9R__"